<template>
  <div class="SellReportPage page">
    <div class="page-title">Global Report</div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeListStore="onChangeListStore" @onChangeOutlet="onChangeOutlet" :disableCompareDate="false" :queryMode="this.query.mode"/>
    <div class="column-filter">
      <UiGlobalReportOption @changeOptionAction="pullGlobalStoresReport" :reportList="reportList" />
    </div>
    <div v-if="$route.name !== 'global-stores'">
      <div class="chart-container">
        <div class="item-title">{{$t('global_report')}}</div>
        <UiChart v-if="!loading" :series="prepareLineChartSeries(report)" :options="prepareLineChartOptions(globalReport)"/>
      </div>
      <div class="chart-container">
        <div class="item-title">{{$t('global_summary_report')}}</div>
        <UiChart v-if="!loading" :series="preparePieChartSeries(report)" :options="preparePieChartOptions(report)" />
      </div>
    </div>
    <div v-if="$route.name === 'global-stores'">
      <div class="chart-container">
        <div class="item-title">{{$t('global_report')}}</div>
        <UiChart v-if="!loading" :series="prepareStoresRPLineChartSeries(report)" :options="prepareStoresRPLineChartOptions(globalReport)"/>
      </div>
      <div class="chart-container">
        <div class="item-title">{{$t('global_summary_report')}}</div>
        <UiChart v-if="!loading" :series="prepareStoresRPPieChartSeries(report)" :options="prepareStoresRPPieChartOptions(report)" />
      </div>
    </div>
    <!-- <UiTableReportCommon :report="report" :colsData="visibleFields"/> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import currencyFormatter from 'currency-formatter'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiChart from '@/components/UiChart'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiGlobalReportOption from '@/components/UiGlobalReportOption'
// import UiTableReportCommon from '@/components/UiTableReportCommon'
import reportType from '@/config/reportType'
import reportListData from '@/constants/reportList'
import i18n from '@/i18n'
export default {
  name: 'GlobalPage',
  components: {
    UiFilterbar,
    UiGlobalReportOption,
    // UiTableReportCommon,
    UiChart
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      query: {
        page: 1,
        limit: 20,
        mode: 'DATE',
        outletIds: null,
        timeZone,
        reportingMode: 'in_store'
      },
      pullFirstTime: null,
      day: null,
      filterType: 'DATE',
      type: 'products',
      isShowColumnsSelect: false,
      reportList: reportListData.globalOptions,
      fields: [
        { key: 'totalRevenue', label: i18n.t('total_revenue'), visible: false },
        { key: 'totalTax', label: i18n.t('tax'), visible: false },
        { key: 'netRevenue', label: i18n.t('net_revenue'), visible: true },
        { key: 'avgOrderValue', label: i18n.t('avg_order_value'), visible: false },
        { key: 'orderCount', label: i18n.t('number_of_orders'), visible: false },
        { key: 'avgItemCount', label: i18n.t('avg_number_of_item_per_order'), visible: false },
        { key: 'revNewCustomer', label: i18n.t('new_customer'), visible: false },
        { key: 'revReturnCustomer', label: i18n.t('returning_customer'), visible: false },
        { key: 'totalRefund', label: i18n.t('refund'), visible: false },
        { key: 'totalDiscount', label: i18n.t('discount'), visible: false }
      ],
      filteredFields: []
    }
  },
  updated () {
    if (this.listStore && this.listStore.length && (!this.allOutlets)) {
      this.setLoading(true)
      this.getCurrencyRatesAllStore(this.listStore.map(store => store.id))
      this.setCommonLoading(true)
      this.getAllOutlets(this.listStore.map(store => store.id))
        .then((data) => {
          this.setCommonLoading(false)
          this.pullGlobalReport(data)
        })
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      globalReport: 'report/getGlobalReport',
      loading: 'common/loading',
      listStore: 'store/getListStore',
      allOutlets: 'outlet/getAllOutLets',
      currencyRatesAllStore: 'currency/getCurrencyRatesAllStore'
    }),
    visibleFields () {
      return this.fields.filter(field => field.visible)
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getGlobalReport',
      setListStore: 'store/updateListStore',
      getAllOutlets: 'outlet/getAllOutletByUser',
      setLoading: 'report/setLoadingReport',
      setCommonLoading: 'report/setCommonLoading',
      getCurrencyRatesAllStore: 'currency/getCurrencyRatesAllStore'
    }),
    pullGlobalReport (data) {
      let newOuletsByStore = {};
      (this.listStore || []).forEach(store => {
        if (store.visible && data) {
          newOuletsByStore = {
            ...newOuletsByStore,
            [store.id]: data[store.id]
          }
        }
      })
      this.getReport({
        type: reportType.globalReport,
        allOutlets: newOuletsByStore,
        query: {
          ...this.query,
          ...this.day
        }
      })
      this.pullFirstTime = true
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      let newOuletsByStore = {};
      (this.listStore || []).forEach(store => {
        if (store.visible && this.allOutlets) {
          newOuletsByStore = {
            ...newOuletsByStore,
            [store.id]: this.allOutlets[store.id]
          }
        }
      })
      this.getReport({
        type: reportType.globalReport,
        allOutlets: newOuletsByStore,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    onChangeListStore (stores) {
      this.setListStore(stores)
      let newOuletsByStore = {};
      (stores || []).forEach(store => {
        if (store.visible && this.allOutlets) {
          newOuletsByStore = {
            ...newOuletsByStore,
            [store.id]: this.allOutlets[store.id]
          }
        }
      })
      this.getReport({
        type: reportType.globalReport,
        allOutlets: newOuletsByStore,
        query: {
          ...this.query,
          ...this.day
        }
      })
    },
    onDefaultFilter (day, type, reportingMode, outletIds, registerIds) {
      this.day = day
      this.day = day
      if (outletIds) {
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      let newOuletsByStore = {};
      (this.listStore || []).forEach(store => {
        if (store.visible && this.allOutlets) {
          newOuletsByStore = {
            ...newOuletsByStore,
            [store.id]: this.allOutlets[store.id]
          }
        }
      })
      this.getReport({
        type: reportType.globalReport,
        allOutlets: newOuletsByStore,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    toggleColumnFilter () {
      this.isShowColumnsSelect = !this.isShowColumnsSelect
    },
    documentClick (e) {
      const el = this.$refs.columnsList
      const target = e.target
      if (el && el !== target && !el.contains(target)) {
        this.isShowColumnsSelect = false
      }
    },
    formartDate (date) {
      return moment(new Date(moment(date).toDate().toUTCString())).format('MMM DD YYYY')
    },
    formatTotal (total) {
      const USDCurrency = (this.currencyRatesAllStore || []).find(currency => currency.toCurrency === 'USD')
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      return currencyFormatter.format(Number(total), { code: !!USDCurrency && !!USDCurrency.toCurrency ? USDCurrency.toCurrency : storeConfig.currency, decimalDigits: 2 })
    },
    prepareLineChartOptions (globalReport) {
      let dateList = []
      Object.keys(globalReport || {}).map(storeId => {
        Object.keys(globalReport[storeId] || {}).map(outletId => {
          const reports = globalReport[storeId][outletId]
          var dateData = reports && reports.items ? Object.keys(reports.items).map(item => item.length < 8 ? item : this.formartDate(item)) : []
          if (dateList.length && dateData.length < dateList.length) {
            return
          }
          dateList = dateData
        })
      })
      return {
        chart: {
          id: 'product-sold-chart',
          type: 'line',
          zoom: {
            enabled: false
          },
          background: '#fff'
        },
        stroke: {
          width: 2
        },
        colors: ['#F3B415', '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8', '#A9D794',
          '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
        ],
        markers: {
          size: 4,
          hover: {
            size: 7,
            sizeOffset: 3
          }
        },
        noData: {
          text: 'No data'
        },
        xaxis: {
          categories: dateList
        },
        yaxis: {
          labels: {
            formatter: value => { return this.formatTotal(value) }
          }
        }
      }
    },
    preparePieChartOptions () {
      const labels = []
      if (this.listStore && this.allOutlets) {
        Object.keys(this.globalReport || {}).map(storeId => {
          const store = this.listStore.find(store => store.id === storeId)
          Object.keys(this.globalReport[storeId] || {}).map(outletId => {
            const outlet = this.allOutlets[storeId].find(outlet => outlet.id === outletId)
            labels.push(`${outlet ? outlet.name : ''}/${store.name}`)
          })
        })
      }
      return {
        chart: {
          id: 'product-sold-chart',
          type: 'pie',
          zoom: {
            enabled: false
          },
          background: '#fff'
        },
        labels,
        colors: ['#F3B415', '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8', '#A9D794',
          '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
        ],
        noData: {
          text: 'No data'
        },
        tooltip: {
          y: {
            formatter: value => {
              return this.formatTotal(value)
            }
          }
        }
      }
    },
    prepareLineChartSeries () {
      const series = []
      if (this.listStore && this.allOutlets) {
        Object.keys(this.globalReport || {}).map(storeId => {
          const store = this.listStore.find(store => store.id === storeId)
          Object.keys(this.globalReport[storeId] || {}).map(outletId => {
            const outlet = this.allOutlets[storeId].find(outlet => outlet.id === outletId)
            const reports = this.globalReport[storeId][outletId]
            const valueList = reports && reports.items ? Object.keys(reports.items).map(item => {
              var total = reports.items[item].netRevenue
              if (total != null && !!this.currencyRatesAllStore && !!this.currencyRatesAllStore.length) {
                var USDCurrency = (this.currencyRatesAllStore || []).find(currency => currency.toCurrency === 'USD' && currency.storeId === reports.items[item].storeId)
                const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
                if (USDCurrency !== null && USDCurrency !== undefined) {
                  total = Number(total) * Number(storeConfig.currency === USDCurrency.toCurrency ? '1' : (USDCurrency.rate || '1'))
                }
              }
              return total || 0
            }) : []
            series.push({
              name: `${outlet ? outlet.name : ''}/${store.name}`,
              data: valueList
            })
          })
        })
      }
      return series
    },
    preparePieChartSeries () {
      const series = []
      if (this.listStore && this.allOutlets) {
        Object.keys(this.globalReport || {}).map(storeId => {
          Object.keys(this.globalReport[storeId] || {}).map(outletId => {
            const reports = this.globalReport[storeId][outletId]
            const valueList = reports && reports.items ? Object.keys(reports.items).map(item => {
              var total = reports.items[item].netRevenue
              if (total != null && !!this.currencyRatesAllStore && !!this.currencyRatesAllStore.length) {
                var USDCurrency = (this.currencyRatesAllStore || []).find(currency => currency.toCurrency === 'USD' && currency.storeId === reports.items[item].storeId)
                const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
                if (USDCurrency !== null && USDCurrency !== undefined) {
                  total = Number(total) * Number(storeConfig.currency === USDCurrency.toCurrency ? '1' : (USDCurrency.rate || '1'))
                }
              }
              return total || 0
            }) : []
            series.push(Number((valueList || []).reduce((prevValue, current) => prevValue + Number(current || 0), 0).toFixed(2)))
          })
        })
      }
      return series
    },
    pullGlobalStoresReport () {
      this.setLoading(true)
      if (this.listStore && this.listStore.length) {
        this.getCurrencyRatesAllStore(this.listStore.map(store => store.id))
        this.getAllOutlets(this.listStore.map(store => store.id))
          .then((data) => {
            this.pullGlobalReport(data)
          })
      }
    },
    prepareStoresRPLineChartOptions (globalReport) {
      let dateList = []
      Object.keys(globalReport || {}).map(storeId => {
        Object.keys(globalReport[storeId] || {}).map(outletId => {
          if (dateList.length) {
            return
          }
          const reports = globalReport[storeId][outletId]
          dateList = reports && reports.items ? Object.keys(reports.items).map(item => item.length < 8 ? item : this.formartDate(item)) : []
        })
      })
      return {
        chart: {
          id: 'product-sold-chart',
          type: 'line',
          zoom: {
            enabled: false
          },
          background: '#fff'
        },
        stroke: {
          width: 2
        },
        colors: ['#F3B415', '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8', '#A9D794',
          '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
        ],
        markers: {
          size: 4,
          hover: {
            size: 7,
            sizeOffset: 3
          }
        },
        noData: {
          text: 'No data'
        },
        xaxis: {
          categories: dateList
        },
        yaxis: {
          labels: {
            formatter: value => { return this.formatTotal(value) }
          }
        }
      }
    },
    prepareStoresRPPieChartOptions () {
      const labels = []
      if (this.listStore && this.allOutlets) {
        Object.keys(this.globalReport || {}).map(storeId => {
          const store = this.listStore.find(store => store.id === storeId)
          Object.keys(this.globalReport[storeId] || {}).map(outletId => {
            labels.push(`${store.name}`)
          })
        })
      }
      return {
        chart: {
          id: 'product-sold-chart',
          type: 'pie',
          zoom: {
            enabled: false
          },
          background: '#fff'
        },
        labels,
        colors: ['#F3B415', '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8', '#A9D794',
          '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
        ],
        noData: {
          text: 'No data'
        },
        tooltip: {
          y: {
            formatter: value => {
              return this.formatTotal(value)
            }
          }
        }
      }
    },
    prepareStoresRPLineChartSeries () {
      const series = []
      if (this.listStore && this.allOutlets) {
        Object.keys(this.globalReport || {}).map(storeId => {
          const store = this.listStore.find(store => store.id === storeId)
          Object.keys(this.globalReport[storeId] || {}).map(outletId => {
            const reports = this.globalReport[storeId][outletId]
            const valueList = reports && reports.items ? Object.keys(reports.items).map(item => {
              var total = reports.items[item].netRevenue
              if (total != null && !!this.currencyRatesAllStore && !!this.currencyRatesAllStore.length) {
                var USDCurrency = (this.currencyRatesAllStore || []).find(currency => currency.toCurrency === 'USD' && currency.storeId === reports.items[item].storeId)
                const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
                if (USDCurrency !== null && USDCurrency !== undefined) {
                  total = Number(total) * Number(storeConfig.currency === USDCurrency.toCurrency ? '1' : (USDCurrency.rate || '1'))
                }
              }
              return total || 0
            }) : []
            series.push({
              name: `${store.name}`,
              data: valueList
            })
          })
        })
      }
      return series
    },
    prepareStoresRPPieChartSeries () {
      const series = []
      if (this.listStore && this.allOutlets) {
        Object.keys(this.globalReport || {}).map(storeId => {
          Object.keys(this.globalReport[storeId] || {}).map(outletId => {
            const reports = this.globalReport[storeId][outletId]
            const valueList = reports && reports.items ? Object.keys(reports.items).map(item => {
              var total = reports.items[item].netRevenue
              if (total != null && !!this.currencyRatesAllStore && !!this.currencyRatesAllStore.length) {
                var USDCurrency = (this.currencyRatesAllStore || []).find(currency => currency.toCurrency === 'USD' && currency.storeId === reports.items[item].storeId)
                const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
                if (USDCurrency !== null && USDCurrency !== undefined) {
                  total = Number(total) * Number(storeConfig.currency === USDCurrency.toCurrency ? '1' : (USDCurrency.rate || '1'))
                }
              }
              return total || 0
            }) : []
            series.push(Number((valueList || []).reduce((prevValue, current) => prevValue + Number(current || 0), 0).toFixed(2)))
          })
        })
      }
      return series
    }
  },
  created () {
    const self = this
    this.setLoading(true)
    if (this.listStore && this.listStore.length && (!this.allOutlets)) {
      this.getCurrencyRatesAllStore(this.listStore.map(store => store.id))
      this.setCommonLoading(true)
      this.getAllOutlets(this.listStore.map(store => store.id))
        .then((data) => {
          this.setCommonLoading(false)
          this.pullGlobalReport(data)
        })
    }

    window.addEventListener('click', function (e) {
    // close dropdown when clicked outside
      if (!self.$el.contains(e.target)) {
        self.isShowColumnsSelect = false
      }
    })
  },
  destroyed () {
    // important to clean up!!
    document.removeEventListener('click', this.documentClick)
  },
  mounted () {
    const tooltip = document.querySelector('div.apexcharts-tooltip')
    if (tooltip) {
      tooltip.style.maxHeight = '300px'
      tooltip.style.overflowY = 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
  .page {
    padding: 0 30px;
  }
  .page-title {
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 140px;
      outline: none;
      border-radius: 4px;
      border: 1px solid #818181;
      background-color: #fff;
    }
  }
  .customize-button {
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }
  .column-filter {
    display: flex;
    justify-content: space-between;
  }
  .column-filter-wrapper {
    text-align: right;
    position: relative;
    margin-bottom: 20px;
    padding: 0 30px;
  }
  ul {
    position: absolute;
    text-align: left;
    right: 0;
    background: #e9eef1;
    padding: 20px;
    top: 100%;
    border: 1px solid #acacac;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    z-index: 12;

    li {
      padding: 5px 0;

      label {
        cursor: pointer;
      }
    }
  }
  .item-title {
    padding: 0 10px;
    margin-right: 2rem;
    margin-bottom: 25px;
    line-height: 1em;
    font-size: 16px;
    font-weight: 700;
    color: #000;
    text-transform: capitalize;
    cursor: pointer;
    text-decoration: none;
  }
  .chart-container {
    background-color: #FFFFFF;
    padding-top: 15px;
    margin-bottom: 25px;
    overflow: auto;
  }
</style>
